import axios from 'axios';

// Use relative URL for production, localhost for development
const API_BASE_URL = process.env.REACT_APP_API_URL || (
  process.env.NODE_ENV === 'production' ? '' : 'http://localhost:5002'
);

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Products API
export const getProducts = async () => {
  const response = await api.get('/api/products');
  return response.data;
};

// Research & Innovation API
export const getResearchPortfolio = async () => {
  const response = await api.get('/api/research');
  return response.data;
};

// Contact API
export const submitContact = async (formData) => {
  const response = await api.post('/api/contact', formData);
  return response.data;
};
